import { ShieldCheck, Handshake, Trophy } from "lucide-react";
import Reveal from "@/components/Reveal";

const PROMISES = [
  {
    icon: ShieldCheck,
    label: "Your Trust",
    sub: "Our Priority",
  },
  {
    icon: Handshake,
    label: "Your Service",
    sub: "Our Commitment",
  },
  {
    icon: Trophy,
    label: "Your Success",
    sub: "Our Goal",
  },
];

export default function SahyogPromise() {
  return (
    <section
      data-testid="sahyog-promise"
      className="relative bg-[#04102B] text-white py-14 md:py-16 overflow-hidden border-y border-[#D4AF37]/20"
    >
      <div className="absolute top-0 left-0 right-0 h-px bg-gradient-to-r from-transparent via-[#D4AF37] to-transparent" />
      <div className="absolute bottom-0 left-0 right-0 h-px bg-gradient-to-r from-transparent via-[#0F6B3D] to-transparent" />

      <div className="relative max-w-7xl mx-auto px-6 md:px-12">
        <Reveal>
          <div className="text-center">
            <p className="font-script italic text-2xl md:text-3xl text-[#F0D788]">
              સહયોગ આપનો… વિકાસ આપનો…
            </p>
            <p className="mt-1 text-white/55 text-sm">Our support · Your growth</p>
          </div>
        </Reveal>

        <div className="mt-10 grid grid-cols-1 md:grid-cols-3 gap-5">
          {PROMISES.map(({ icon: Icon, label, sub }, i) => (
            <Reveal key={label} delay={i * 100}>
              <div
                data-testid={`promise-${label.toLowerCase().replace(/\s+/g, "-")}`}
                className="flex items-center gap-4 rounded-2xl p-5 border border-[#D4AF37]/30 bg-gradient-to-r from-[#0F6B3D]/15 to-transparent hover:border-[#D4AF37]/70 transition-all"
              >
                <span className="shrink-0 w-12 h-12 rounded-full grid place-items-center bg-[#D4AF37]/15 text-[#F0D788] border border-[#D4AF37]/40">
                  <Icon size={22} />
                </span>
                <div>
                  <div className="font-display text-xl uppercase tracking-wider leading-none text-white">
                    {label}
                  </div>
                  <div className="text-[#D4AF37] text-sm uppercase tracking-[0.18em] mt-1.5">
                    {sub}
                  </div>
                </div>
              </div>
            </Reveal>
          ))}
        </div>
      </div>
    </section>
  );
}
